import { PlusShopProductListPage } from './PlusShopProductList.page';

export const plusShopProductListRouter = {
  '/@/plus_products': PlusShopProductListPage,
};
